<template>
  <div id="app">
    <router-view />
    <PWAUpdatePrompt />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import PWAUpdatePrompt from "./components/PWAUpdatePrompt.vue";
import { setGlobalErrorHandler, type ErrorInfo } from "@/utils/errorHandler";
import { useNotification } from "@/composables/useNotification";

onMounted(() => {
  const { notifyError } = useNotification();
  setGlobalErrorHandler((error: ErrorInfo) => {
    notifyError(error.message);
  });
});
</script>

<style>
/* 全局样式 */
#app {
  min-height: 100vh;
  background-color: #f9fafb;
}

.dark #app {
  background-color: #111827;
}

/* 移动端优化 */
@media (max-width: 640px) {
  #app {
    font-size: 14px;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.dark ::-webkit-scrollbar-track {
  background: #374151;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.dark ::-webkit-scrollbar-thumb {
  background: #6b7280;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  button,
  a,
  input,
  select,
  textarea {
    min-height: 44px;
    min-width: 44px;
  }

  .touch-target {
    min-height: 44px;
    min-width: 44px;
  }
}

/* 打印样式 */
@media print {
  .no-print {
    display: none !important;
  }
}
</style>
